import { render, staticRenderFns } from "./AppManager.vue?vue&type=template&id=27113980&"
import script from "./AppManager.vue?vue&type=script&lang=js&"
export * from "./AppManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27113980')) {
      api.createRecord('27113980', component.options)
    } else {
      api.reload('27113980', component.options)
    }
    module.hot.accept("./AppManager.vue?vue&type=template&id=27113980&", function () {
      api.rerender('27113980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/AppManager.vue"
export default component.exports